import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              精选优质内容，发现更多好片
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {carouselItems.map((item) => (
              <article
                key={item.id}
                className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={`春色影视 - ${item.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-primary-500 font-medium mb-2">{item.subtitle}</p>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {item.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}